// extracted by mini-css-extract-plugin
module.exports = {"category":"V_dH","wrapp":"V_dJ","category__wrapper":"V_dK"};